import { createSlice } from '@reduxjs/toolkit';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { init_local_words_set_word_for_adding_related } from './local_words_set_word_for_adding_related_words';
import { init_local_words_upsert } from './local_words_upsert';
import { init_local_words_with_related_words_upsert } from './local_words_with_related_words_upsert';
import { init_local_word_with_related_words_create_in_progress_add } from './related_words_create/local_word_with_related_words_create_in_progress_add';
import { init_local_word_with_related_words_create_in_progress_delete } from './related_words_create/local_word_with_related_words_create_in_progress_delete';
import { init_local_words_similar_upsert } from './related_words_create/local_words_similar_upsert';
import { init_remote_word_with_related_words_create } from './related_words_create/remote_word_with_related_words_create';
import { init_local_word_with_related_words_get_in_progress_add } from './related_words_get/local_word_with_related_words_get_in_progress_add';
import { init_local_word_with_related_words_get_in_progress_delete } from './related_words_get/local_word_with_related_words_get_in_progress_delete';
import { init_remote_word_with_related_words_get } from './related_words_get/remote_word_with_related_words_get';
import { StateWords } from './state_words';
import { init_local_words_translating_in_progress_add } from './translate_from_english/local_words_translating_in_progress_add';
import { init_local_words_translating_in_progress_delete } from './translate_from_english/local_words_translating_in_progress_delete';
import { init_remote_words_translate_from_english } from './translate_from_english/remote_words_translate_from_english';
import { init_remote_words_translate_from_english_with_context } from './translate_from_english/remote_words_translate_from_english_with_context';

const initialState: StateWords = {
  word_english_for_adding_related_words: '',

  words_with_related_words_map: new Map(),

  words_vocabularies: new Map(),

  words_translating_in_progress: new Map(),

  words_with_related_words_get_in_progress: new Set(),

  words_with_related_words_create_in_progress: new Set(),
};

export const slice_words = createSlice({
  name: ENUM__redux_slice.WORDS,
  initialState,
  reducers: {
    set_word_for_adding_related: init_local_words_set_word_for_adding_related,

    words_similar_upsert: init_local_words_similar_upsert,
    words_upsert: init_local_words_upsert,

    translating_in_progress_add: init_local_words_translating_in_progress_add,
    translating_in_progress_delete: init_local_words_translating_in_progress_delete,

    words_with_related_words_upsert: init_local_words_with_related_words_upsert,

    word_with_related_words_get_in_progress_add: init_local_word_with_related_words_get_in_progress_add,
    word_with_related_words_get_in_progress_delete: init_local_word_with_related_words_get_in_progress_delete,

    word_with_related_words_create_in_progress_add: init_local_word_with_related_words_create_in_progress_add,
    word_with_related_words_create_in_progress_delete: init_local_word_with_related_words_create_in_progress_delete,
  },
  extraReducers: builder => {
    init_remote_words_translate_from_english(builder);
    init_remote_words_translate_from_english_with_context(builder);

    init_remote_word_with_related_words_get(builder);
    init_remote_word_with_related_words_create(builder);

    builder.addCase(LOCAL__global_reset, state => {
      return initialState;
    });
  },
});
